const retryLazy = (importFn, maxRetries = 3, baseDelay = 1000) => {
  return new Promise((resolve, reject) => {
    const attempt = (retryCount) => {
      importFn()
        .then(resolve)
        .catch((error) => {
          if (retryCount >= maxRetries) {
            reject(error);
            return;
          }
          const delay = baseDelay * Math.pow(2, retryCount);
          // eslint-disable-next-line no-promise-executor-return
          setTimeout(() => attempt(retryCount + 1), delay);
        });
    };
    attempt(0);
  });
};

export default retryLazy;
